import { useHandleDeviceUnknown } from "@/hooks";
import { getStorage } from "@/shared/store";
import type { DeviceType } from "@/types";

import {
  DearisAdapterDataConfirm,
  DearisControllerDataConfirm,
  // AdapterDataConfirm,
  DearisDataConfirm,
  EntranceDataConfirm,
  LiteDataConfirm,
  PatmoDataConfirm,
} from "./data-confirm";

const DataConfirmWrapper = () => {
  const deviceType = getStorage("deviceType") as DeviceType;
  const { toastAndToSelectDevice } = useHandleDeviceUnknown();
  switch (deviceType) {
    // case "adapter":
    //   return <AdapterDataConfirm />;
    case "PATMO":
      return <PatmoDataConfirm />;
    case "PabbitLite":
      return <LiteDataConfirm />;
    case "dearisController": {
      const ctx = getStorage("dearisEntryContext");
      if (ctx === "adapterRegister") return <DearisAdapterDataConfirm />;
      if (ctx === "sharedBuildingList") return <DearisDataConfirm />;
      return <DearisControllerDataConfirm />;
    }
    case "dearisEntrance":
      return <EntranceDataConfirm />;
    default:
      toastAndToSelectDevice();
      return null;
  }
};

export default DataConfirmWrapper;
